import { useRuntimeConfig } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import type {
  ChatRequestBody,
  MessageRequestBody,
} from '~/api/shopping-assistant/types'

/**
 * API client for the Shopping Assistant service.
 */
export function useShoppingAssistantApi() {
  const $httpFetch = useHttpFetch()
  const config = useRuntimeConfig()

  // FIXME To remove when the shopping-agent service is deployed in preprod
  const baseURL =
    config.public.ENVIRONMENT === 'local' ? 'http://localhost:8000' : undefined

  const startChat = async (chatId: string | null, body: ChatRequestBody) => {
    let responseStatus = 0

    const onResponse = ({ response }: { response: { status: number } }) => {
      responseStatus = response.status
    }

    if (chatId) {
      const data = await $httpFetch('/shopping-agent/v1/chat/:chatId', {
        method: 'POST',
        baseURL,
        body,
        pathParams: { chatId },
        onResponse,
      })

      return { data, status: responseStatus }
    }

    const data = await $httpFetch('/shopping-agent/v1/chat', {
      method: 'POST',
      baseURL,
      body,
      onResponse,
    })

    return { data, status: responseStatus }
  }

  const sendMessage = async (chatId: string, body: MessageRequestBody) => {
    const data = await $httpFetch('/shopping-agent/v1/chat/:chatId/message', {
      method: 'POST',
      baseURL,
      body,
      pathParams: { chatId },
    })

    return data
  }

  return { startChat, sendMessage }
}
